import ManageMainBannerEditContainer from './ManageMainBannerEditContainer';

export default ManageMainBannerEditContainer;
